import { Box, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import ModalComponent from "../../components/ModalComponent";
import { usePhotoCondominioEdit } from "../../hooks/pages/usePhotoCondominioEdit";

export default function PhotoCondominiumEdit({
  open,
  setOpen,
  photo,
  getList
}) {
  const { initialValues, validationSchema, onSubmit } = usePhotoCondominioEdit({
    photo,
    getPhotos: getList,
    handleClose: setOpen
  });

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          isSubmitting
        }) => {
          return (
            <Form id="form-photo">
              <ModalComponent
                open={open}
                title="Dados da Foto"
                maxWidth={"sm"}
                handleOpen={setOpen}
                buttonOkType={"submit"}
                disabledClick={isSubmitting}
                buttonForm="form-photo"
              >
                <TextField
                  margin="normal"
                  variant="filled"
                  fullWidth
                  label="Descrição"
                  name="Descricao"
                  value={values.Descricao}
                  onBlur={handleBlur}
                  disabled={isSubmitting}
                  onChange={handleChange}
                  helperText={touched.Descricao && errors.Descricao}
                  error={Boolean(touched.Descricao && errors.Descricao)}
                />
                <TextField
                  margin="normal"
                  variant="filled"
                  fullWidth
                  label="Ordem"
                  name="Ordem"
                  value={values.Ordem}
                  onBlur={handleBlur}
                  disabled={isSubmitting}
                  onChange={handleChange}
                  helperText={touched.Ordem && errors.Ordem}
                  error={Boolean(touched.Ordem && errors.Ordem)}
                />
              </ModalComponent>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
}
